import React, { useEffect, useRef, useState, ChangeEvent } from "react";
import "./home.scss";
import Paragraph from "../components/atoms/paragraph/paragraph";
import Banner from "../components/molecules/banner/banner";
import Body from "../components/organisms/body/body";
import image from "../assets/images/Logo-garantias.jpg";
import Input from "../components/atoms/input/input";
import axios from "axios";
import { resolver } from "../util/objectUtilities";
import { createHash } from "crypto";




function Home() {
  const saveableCanvas = useRef();
  const textBody = useRef();
  const [torres, setTorres] = useState();
  const [proyectos, setProyectos] = useState();
  const [inmuebles, setInmuebles] = useState();
  const [message, setMessage] = useState("");
  const [message2, setMessage2] = useState("");
  const [asunto, setAsunto] = useState("");
  const [error, setError] = useState(false);
  const [state, setState] = useState();
  const [state2, setState2] = useState();
  const [state3, setState3] = useState();
  const [state4, setState4] = useState();
  const [state5, setState5] = useState();
  const [formValues, setFormValues] = useState({
    tipoUsuario: "",
    nombre: "",
    apellido: "",
    tipoDoc: "",
    numeroDoc: "",
    email: "",
    celular: "",
    proyecto: "",
    torre: "",
    inmueble:"",
    asesor: "",
    pregunta1: "",
    pregunta2: "",
    pregunta3: "",
    pregunta4: "",
    pregunta5: "",
    temperatura: "",
    archivo1:"",
    archivos_visible :false,
    boton_visible :false,
    boton_siguiente_visible :true,
    asunto:"",
    descripcion:""
  });

  const recaptchaRef = useRef();

  
  function KeyPress(event) {
    if (event.ctrlKey && event.key === "z") {
      saveableCanvas.current.undo();
    }
  }

  if (typeof document !== "undefined") {
    document.addEventListener("keydown", KeyPress);
  }

  function handleInput(name, value) {
    name &&
      setFormValues((s) => {
        return {
          ...s,
          [name]: value,
        };
      });
  }

  useEffect(() => {
    async function fetchData() {
      console.log("ENTRO PROYECTO");
      // Fetch data
      const newPost = {
        str_Id: "hola mundo"
      };
      const resp = await axios.post('https://sys.conexo.com.co/Contex_WS/serviciosCRM/ContexCRM/getProyectos', newPost, {auth: {
        username: 'contex_user',
        password: 'C0nt3X_2023*'}
      });
      //console.log(resp.data.objProyectos);
      const results = []
      // Store results in the results array
      resp.data.objProyectos.forEach((value) => {
        results.push({
          value: value.str_Id,
          label: value.str_NombreProyecto,
        });
      });
      //console.log("PROYECTO", formValues.proyecto);
      // Update the options state
      setProyectos([ 
        ...results
      ])
    }

    // Trigger the fetch
    fetchData();
  }, []);

  async function handleSubmit() {
    try {
        setError(false);
        setMessage2("Espere un momento mientras se genera su numero de caso...Puede tardar un par de minutos.");
        handleInput("boton_visible",false);
        const answer_array_inmueble = formValues.inmueble.split('||');
        const answer_array_proyecto= formValues.proyecto.split('||');
        const answer_array_torre= formValues.torre.split('||');
        let strBase64 = ''; 
        let strBase64_2 = ''; 
        let strBase64_3 = ''; 
        let strBase64_4 = ''; 
        let strBase64_5 = ''; 
        let strFileName = '';
        let strFileName_2 = '';
        let strFileName_3 = '';
        let strFileName_4 = '';
        let strFileName_5 = '';
        console.log("str_Cedula: ", formValues.numeroDoc);
        console.log("str_IdInmueble: ", answer_array_inmueble[0]);
        
        
        if (state == null){
          console.log("Archivo 1 Esta vacio");
        }else{
          let reader = new FileReader()
          reader.readAsDataURL(state.selectedFile)
          await new Promise(resolve => reader.onload = () => resolve());
          strBase64 = reader.result.split(',')[1];
          strFileName = state.selectedFile.name;
          console.log("strBase64: ", strBase64);
        }
  
        if (state2 == null){
          console.log("Archivo 2 Esta vacio");
        }else{
          let reader2 = new FileReader()
          reader2.readAsDataURL(state2.selectedFile)
          await new Promise(resolve => reader2.onload = () => resolve());
          strBase64_2 = reader2.result.split(',')[1];
          strFileName_2 = state2.selectedFile.name;
        }
  
        if (state3 == null){
          console.log("Archivo 3 Esta vacio");
        }else{
          let reader3 = new FileReader()
          reader3.readAsDataURL(state3.selectedFile)
          await new Promise(resolve => reader3.onload = () => resolve());
          strBase64_3 = reader3.result.split(',')[1];
          strFileName_3 = state3.selectedFile.name;
        }
  
        if (state4 == null){
          console.log("Archivo 4 Esta vacio");
        }else{
          let reader4 = new FileReader()
          reader4.readAsDataURL(state4.selectedFile)
          await new Promise(resolve => reader4.onload = () => resolve());
          strBase64_4 = reader4.result.split(',')[1];
          strFileName_4 = state4.selectedFile.name;
        }
        
        if (state5 == null){
          console.log("Archivo 5 Esta vacio");
        }else{
          let reader5 = new FileReader()
          reader5.readAsDataURL(state5.selectedFile)
          await new Promise(resolve => reader5.onload = () => resolve());
          strBase64_5 = reader5.result.split(',')[1];
          strFileName_5 = state5.selectedFile.name;
        }
        
        const newPost = {
          str_Base64:strBase64,
          str_FileName: strFileName,
          str_Base64_2:strBase64_2,
          str_FileName_2: strFileName_2,
          str_Base64_3:strBase64_3,
          str_FileName_3: strFileName_3,
          str_Base64_4:strBase64_4,
          str_FileName_4:strFileName_4,
          str_Base64_5:strBase64_5,
          str_FileName_5: strFileName_5,
          str_ContactId: formValues.numeroDoc,
          str_ProyectoId: answer_array_proyecto[0],
          str_TorreId:answer_array_torre[0],
          str_InmuebleId: answer_array_inmueble[0],
          str_Asunto: formValues.asunto,
          str_Descripcion: formValues.descripcion,
          str_Celular:formValues.celular,
          str_Nombres:formValues.nombre + " " + formValues.apellido,
          str_Cedula:formValues.numeroDoc,
          str_Correo:formValues.email
        
         };
        const resp = await axios.post('https://sys.conexo.com.co/Contex_WS/serviciosCRM/ContexCRM/createCaso', newPost, {auth: {
          username: 'contex_user',
          password: 'C0nt3X_2023*'}
        });
       
        console.log("resp: ", resp);
        if (resp.data.str_ErrorCode ==='0'){
          //handleInput("archivos_visible",true);
          setMessage2("Numero de caso generado: " + resp.data.str_NumeroCaso);
          //alert("Numero de caso generado: " + resp.data.str_NumeroCaso);
        }else{
          setError(true);
          setMessage2(resp.data.str_ErrorMessage);
          alert(resp.data.str_ErrorMessage);
        }
      
    } catch (e) {
      setError(true);
      setMessage2("Se genero un error en el proceso. Intentenlo nuevamente... ");
      console.error(e);
      if (typeof e.response !== "undefined") {
        console.error(e.response.data);
      }
      
    }
  }

  async function getTorres(proyecto) {
    try {
      console.log("ENTRO TORRES");
      console.log("proyecto", proyecto);
      if (proyecto!==''){
            const answer_array = proyecto.split('||');
            console.log("PROYECTO", answer_array[0]);
            const newPost = {
              str_Id: answer_array[0]
             };
            const resp = await axios.post('https://sys.conexo.com.co/Contex_WS/serviciosCRM/ContexCRM/getTorre', newPost, {auth: {
              username: 'contex_user',
              password: 'C0nt3X_2023*'}
            });
            //console.log(resp.data.objProyectos);
            const results = []
            // Store results in the results array
            resp.data.objTorres.forEach((value) => {
              results.push({
                value: value.str_Id,
                label: value.str_NombreTorre,
              });
            });
            //console.log("results", results);
            // Update the options state
            setTorres([ 
              ...results
            ])
      }
      
      
    } catch (e) {
      setError(true);
      console.error(e);
    }
  }

  async function getInmuebles(torre) {
    try {
      console.log("ENTRO INMUEBLES");
      console.log("formValues.torre", torre);
      if (torre!==''){
            const answer_array = torre.split('||');
            console.log("Inmueble", answer_array[0]);
            const newPost = {
              str_Id: answer_array[0]
             };
            const resp = await axios.post('https://sys.conexo.com.co/Contex_WS/serviciosCRM/ContexCRM/getInmuebles', newPost, {auth: {
              username: 'contex_user',
              password: 'C0nt3X_2023*'}
            });
            //console.log(resp.data.objProyectos);
            const results = []
            // Store results in the results array
            resp.data.objInmuebles.forEach((value) => {
              results.push({
                value: value.str_Id,
                label: value.str_NombreInmueble,
              });
            });
            //console.log("results", results);
            // Update the options state
            setInmuebles([ 
              ...results
            ])
      }
      
      
    } catch (e) {
      setError(true);
      console.error(e);
    }
  }

   async function getBase64() {
    try {
      console.log("Base64");
      let strBase64 = ''; 
      let reader = new FileReader()
      reader.readAsDataURL(state.selectedFile)
      await new Promise(resolve => reader.onload = () => resolve());
      strBase64 = reader.result
      console.log("strBase64: ", strBase64);
      const newPost = {
        str_Base64: strBase64,
        str_FileName: state.selectedFile.name
       };
      const resp = await axios.post('https://sys.conexo.com.co/Contex_WS/serviciosCRM/ContexCRM/createFile', newPost, {auth: {
        username: 'contex_user',
        password: 'C0nt3X_2023*'}
      });
      console.log("resp: ", resp);
      
    } catch (e) {
      setError(true);
      console.error(e);
    }
  }

  async function nextButton() {
    try {
      const answer_array = formValues.inmueble.split('||');
      const answer_array_torre = formValues.torre.split('||');
      const answer_array_proyecto = formValues.proyecto.split('||');
      console.log("str_Cedula: ", formValues.numeroDoc);
      console.log("str_IdInmueble: ", answer_array[0]);
     
      const newPost = {
        str_Cedula: formValues.numeroDoc,
        str_IdInmueble: answer_array[0],
        str_CorreoElectronico: formValues.email,
        str_Proyecto:answer_array_proyecto[0],
        str_Torre:answer_array_torre[0]
       };
      const resp = await axios.post('https://sys.conexo.com.co/Contex_WS/serviciosCRM/ContexCRM/getPropietario', newPost, {auth: {
        username: 'contex_user',
        password: 'C0nt3X_2023*'}
      });
      console.log("resp: ", resp);
      if (resp.data.str_ErrorCode ==='100'){
        handleInput("archivos_visible",true);
        handleInput("boton_visible",true);
        handleInput("boton_siguiente_visible",false);
        setMessage("");
      }else{
        setError(true);
        setMessage(resp.data.str_ErrorMessage);
      }
      
      //handleInput("archivos_visible",true);
      
    } catch (e) {
      setError(true);
      console.error(e);
    }
  }

  function cleanForm() {
    setFormValues(() => {
      return Object.keys(formValues).reduce((result, item) => {
        return { ...result, [item]: "" };
      }, {});
    });
  }

  return (
    <Body className="home">
      <Banner src={image} />
      <div ref={textBody}>
        <Paragraph className = "inicio"><center>
          Recuerde que solo se atienden las solicitudes realizadas por el propietario.
          </center></Paragraph>
      </div>
    
      <div>
      {message && (
            <Paragraph><center><span className={`mssg${error ? "-error" : ""}`}>{message}</span></center></Paragraph>
              )}
      </div> 
      <form
        id="mainForm"
        className="forms"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
        style={{ marginLeft: "auto",
                marginRight: "auto" 
              }}
      >
        <div className="col-md-12"><center>
          
          <div className="col-md-12" >
            <Input
              name="nombre"
              required={true}
              value={formValues.nombre}
              setValue={handleInput}
              label="Nombres"
              type="text"
            ></Input>
            <Input
              name="apellido"
              required={true}
              value={formValues.apellido}
              setValue={handleInput}
              label="Apellidos"
              type="text"
            ></Input>
            <Input
              name="numeroDoc"
              required={true}
              value={formValues.numeroDoc}
              setValue={handleInput}
              label="Cedula"
              type="number"
            ></Input>
            <Input
              name="tipoUsuario"
              required={true}
              value={formValues.tipoUsuario}
              setValue={handleInput}
              label="Tipo de cliente"
              type="select"
            >
              <option value="">Seleccione un Tipo</option>
              <option value="">Propietario</option>
              <option value="Visitante">Administracion del proyeto</option>
            </Input>
            
            
            <Input
              name="email"
              required={true}
              value={formValues.email}
              setValue={handleInput}
              label="Correo Electrónico"
              type="text"
            ></Input>
            <Input
              name="celular"
              required={true}
              value={formValues.celular}
              setValue={handleInput}
              label="Celular"
              type="number"
            ></Input>
            <div onChange={(e) => {
                console.log("Onchange Proyecto", e.target.value);
                e.preventDefault();
                getTorres(e.target.value);
              }}>
            <Input
              name="proyecto"
              required={true}
              value={formValues.proyecto}
              setValue={handleInput}
              label="Proyecto"
              type="select"
              
            >
              <option value="">Seleccione un Proyecto</option>
              {Array.isArray(proyectos) &&
                proyectos.map((proye) => (
                  <option
                    key={proye.value}
                    value={`${proye.value}||${proye.label}`}
                  >
                    {proye.label}
                  </option>
                ))}
            </Input>
            </div>
            
            <div className="cell" onChange={(e) => {
                console.log("Onchange Torre", e.target.value);
                e.preventDefault();
                getInmuebles(e.target.value);
              }}>
                <td><Input
                  name="torre"
                  required={true}
                  value={formValues.torre}
                  setValue={handleInput}
                  label="Torre"
                  type="select"
                >
                  <option value="">Seleccione una torre</option>
                  {Array.isArray(torres) &&
                    torres.map((torre) => (
                      <option
                        key={torre.value}
                        value={`${torre.value}||${torre.label}`}
                      >
                        {torre.label}
                      </option>
                    ))}
                </Input></td>
                </div>
            <div>
                <div className="pull-left">
                
                <td>
                  <Input
                    name="inmueble"
                    required={true}
                    value={formValues.inmueble}
                    setValue={handleInput}
                    label="Inmueble"
                    type="select"
                  >
                    <option value="">Seleccione un inmueble</option>
                    {Array.isArray(inmuebles) &&
                      inmuebles.map((inmueble) => (
                        <option
                          key={inmueble.value}
                          value={`${inmueble.value}||${inmueble.label}`}
                        >
                          {inmueble.label}
                        </option>
                      ))}
                  </Input></td>
                 
                
                </div>
                
            </div>
            {formValues.boton_siguiente_visible &&
            <button
                      style={{ marginLeft: "auto" }}
                      onClick={(e) => {
                        e.preventDefault();
                        nextButton();
                      }}
                      className="btn2"
                    >
                      Siguiente
            </button>}
            <div className="col-md-12">
                {formValues.archivos_visible &&
                <Paragraph>SELECCIONAR ARCHIVOS:</Paragraph>}
                
                
                <tr>
                <td>
                <div className="cell" onChange={(e) => {
                console.log("Onchange Asunto", e.target.value.length );
                e.preventDefault();
                setAsunto(e.target.value);
                if (e.target.value.length > 50){
                  //window.alert("El asunto debe tener maximo 50 caractares");
                  setAsunto(e.target.value.substring(0,50));
                  handleInput("asunto",e.target.value.substring(0,50));
                }
              }}>

                {formValues.archivos_visible &&
                <Input
                  name="asunto"
                  required={true}
                  value={asunto}
                  setValue={handleInput}
                  label="Asunto"
                  type="text"
                ></Input>}
                </div>
                </td>
                </tr>
                <tr>
                <td>
                <Paragraph></Paragraph>
                {formValues.archivos_visible &&
                <label className="left">Descripción*</label>}
                
                {formValues.archivos_visible &&
                <textarea
                  className="text_area"
                  id = "descripcion"
                  name="descripcion"
                  required={true}
                  cols="40" rows="5"
                  onChange={(e) => {                    
                    e.preventDefault();
                    handleInput("descripcion",e.target.value);
                  }}
                ></textarea>}</td>
                </tr>
                <tr>
                <td>
                <Paragraph></Paragraph>
                {formValues.archivos_visible &&
                <input type="file" 
                      label="Archivo 1"
                      onChange={(e) => {
                            setState({ selectedFile: e.target.files[0] });
                            //console.log("state", e.target.files[0]);
                            if (e.target.files[0].size>40000000){
                              console.log("Tamano Superado", e.target.files[0].size);
                              setError(true);
                              setMessage2("El archivo no puede superar los 40MB");
                              handleInput("boton_visible",false);
                            }else{
                              console.log("Tamano OK", e.target.files[0].size);
                              setMessage2("");
                              handleInput("boton_visible",true);
                            }
                            
                          }} />}
                </td>
                </tr>
                
                
                <tr>
                <td>
                {formValues.archivos_visible &&
                <input type="file" 
                      label="Archivo 2"
                      onChange={(e) => {
                            setState2({ selectedFile: e.target.files[0] });
                            //console.log("state", e.target.files[0]);
                            if (e.target.files[0].size>40000000){
                              console.log("Tamano Superado", e.target.files[0].size);
                              setError(true);
                              setMessage2("El archivo no puede superar los 40MB");
                              handleInput("boton_visible",false);
                            }else{
                              console.log("Tamano OK", e.target.files[0].size);
                              setMessage2("");
                              handleInput("boton_visible",true);
                            }
                          }} />}
                </td>
                </tr>
                
                
                <tr>
                <td>
                {formValues.archivos_visible &&
                <input type="file" 
                      label="Archivo 3"
                      onChange={(e) => {
                            setState3({ selectedFile: e.target.files[0] });
                            if (e.target.files[0].size>40000000){
                              console.log("Tamano Superado", e.target.files[0].size);
                              setError(true);
                              setMessage2("El archivo no puede superar los 40MB");
                              handleInput("boton_visible",false);
                            }else{
                              console.log("Tamano OK", e.target.files[0].size);
                              setMessage2("");
                              handleInput("boton_visible",true);
                            }
                            //console.log("state", e.target.files[0]);
                          }} />}
                </td>
                </tr>
                <tr>
                <td>
                {formValues.archivos_visible &&
                <input type="file" 
                      label="Archivo 4"
                      onChange={(e) => {
                            setState4({ selectedFile: e.target.files[0] });
                            //console.log("state", e.target.files[0]);
                            if (e.target.files[0].size>40000000){
                              console.log("Tamano Superado", e.target.files[0].size);
                              setError(true);
                              setMessage2("El archivo no puede superar los 40MB");
                              handleInput("boton_visible",false);
                            }else{
                              console.log("Tamano OK", e.target.files[0].size);
                              setMessage2("");
                              handleInput("boton_visible",true);
                            }
                          }} />}
                </td>
                </tr>
                <tr>
                <td>
                
                {formValues.archivos_visible &&
                <input type="file" 
                      label="Archivo 5"
                      onChange={(e) => {
                            setState5({ selectedFile: e.target.files[0] });
                            //console.log("state", e.target.files[0]);
                            if (e.target.files[0].size>40000000){
                              console.log("Tamano Superado", e.target.files[0].size);
                              setError(true);
                              setMessage2("El archivo no puede superar los 40MB");
                              handleInput("boton_visible",false);
                            }else{
                              console.log("Tamano OK", e.target.files[0].size);
                              setMessage2("");
                              handleInput("boton_visible",true);
                            }
                          }} />}     
                </td> 
                </tr>   
                
                {formValues.boton_visible &&
                <button className="btn2" type="submit">
                ENVIAR
                </button>}
            </div>     
          </div>
          </center>
        </div>
        
      </form>
      <div>
      {message2 && (
            <Paragraph><center><span className={`mssg${error ? "-error" : ""}`}>{message2}</span></center></Paragraph>
              )}
      </div> 
      
      
    </Body>
  );
}

export default Home;
